import React from 'react';

import { EmailsBox, EmailsBoxHandle } from '../EmailsBox/EmailsBox';
import Loading from '../UI/Loading/Loading';

interface RunTestFooterProps {
  onClose: () => void;
  handleStartClick?: () => void;
  loading: boolean;
  runTestEmails: string[];
  setRunTestEmails: React.Dispatch<React.SetStateAction<string[]>>;
  emailsBoxRef: React.Ref<EmailsBoxHandle>;
  isImportErrors?: boolean;
  submitButtonDisabled?: boolean;
}

const RunTestFooter = ({
  onClose,
  handleStartClick,
  loading,
  runTestEmails,
  setRunTestEmails,
  emailsBoxRef,
  isImportErrors,
  submitButtonDisabled
}: RunTestFooterProps) => {
  const handleCancelClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    onClose();
  };

  const disableSubmitButton = isImportErrors || loading || submitButtonDisabled;

  return (
    <>
      <hr style={{ marginTop: '20px' }} />
      <p
        style={{
          marginLeft: '48px',
          color: '#888888',
          fontWeight: '400',
          fontSize: '16px'
        }}
      >
        Add additional recipient emails (@samsung.com or @cheil.com) that should receive the test results notification.
        Press Enter or space to submit. Use a comma or semicolon as a separator when adding multiple addresses.
      </p>

      <EmailsBox ref={emailsBoxRef} items={runTestEmails} setItems={setRunTestEmails} />

      <div className="run-test-buttons-section">
        <button id={'cancel'} type={'button'} onClick={handleCancelClick}>
          Cancel
        </button>

        <button
          className="loading-button"
          id={'start'}
          disabled={disableSubmitButton}
          type={'submit'}
          onClick={handleStartClick}
        >
          {loading ? <Loading /> : 'Start'}
        </button>
      </div>
    </>
  );
};

export default RunTestFooter;
